// Nome de canal se monta em UM lugar só de cada lado: aqui, no front, e nos
// helpers do publisher em Ruby do web. Antes cada tela concatenava a sua string,
// e o par publisher/subscriber só era visível para quem procurasse os dois.
//
// Este repo não tem pusher-js: o cliente é o do host (o web renderiza a pwa
// dentro do layout dele), então nada aqui instancia Pusher.

export function client() {
  return (window.CDRWEB && window.CDRWEB.pusher && window.CDRWEB.pusher.client) || null;
}

// Upload de anexo pelo QR: o <token_key> é o segredo do link de upload.
export function uploadChannel(tokenKey) {
  return `private-upload-token-${tokenKey}`;
}

// Transições de estado das tentativas de UMA proposta: recurso primeiro, escopo
// em pares <entidade>-<id> do mais largo ao mais estreito.
export function attemptsChannel(accountId, proposalId) {
  return `private-attempts-account-${accountId}-proposal-${proposalId}`;
}
